import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const OperatorCodesPage = lazy(() =>
  import('@/pages/ads/operator-codes/list-page').then((m) => ({ default: m.OperatorCodesPage })),
);

export const Route = createFileRoute('/_app/ads/operator-codes')({
  beforeLoad: requireMenuOrRedirect(
    'menu:ads-admin:operators',
    '/ads/accounts',
  ),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <OperatorCodesPage />
    </Suspense>
  ),
});
